import React from 'react'
import Listing from './Listing'
import { Box } from '@mui/material'
import HeaderTitleHoc from 'app/components/HeaderTitleHoc'

const LogExpences = () => {
  return (
    <Box sx={{mt:-4}}>
        <Listing/>
    </Box>
  )
}

export default HeaderTitleHoc(LogExpences,"Log Expenses")